import { APIService } from "shared/services";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { IDataKeys, IJSONAPIItem, IAPIError } from "shared/types";

interface IJSONAPIPermission {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIPermissionTypeCollection {
  [IDataKeys.permissionType]: IJSONAPIPermission;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export interface IJSONAPIBandUserPermissionsCollection {
  [IDataKeys.bandUser]: IJSONAPIPermission;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class PermissionsService {
  static getPermissionTypes = (
    queryParams?: string | { [key: string]: any }
  ): Promise<IJSONAPIPermissionTypeCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const permissionTypes: unknown = await APIService.get({
          path: API_ENDPOINTS.PERMISSION_TYPES,
          data: queryParams,
        });
        resolve(permissionTypes as IJSONAPIPermissionTypeCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(
          API_ERROR_CODES.GET_PERMISSION_TYPES
        );
        reject(error);
      }
    });

  static getBandUsersPermissions = (
    queryParams?: string | { [key: string]: any }
  ): Promise<IJSONAPIBandUserPermissionsCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const bandUsers: unknown = await APIService.get({
          path: API_ENDPOINTS.BAND_USER_PERMISSIONS,
          data: queryParams,
        });

        resolve(bandUsers as IJSONAPIBandUserPermissionsCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(
          API_ERROR_CODES.GET_BAND_USER_PERMISSIONS
        );
        reject(error);
      }
    });

  static getUserPermissions = (
    userId: string,
    queryParams?: string | { [key: string]: any }
  ): Promise<IJSONAPIBandUserPermissionsCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const bandUser: unknown = await APIService.get({
          path: API_ENDPOINTS.USER_PERMISSIONS(userId),
          data: queryParams,
        });
        resolve(bandUser as IJSONAPIBandUserPermissionsCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(
          API_ERROR_CODES.GET_BAND_USER_PERMISSIONS
        );
        reject(error);
      }
    });

  static editUserPermissions = (
    userId: string,
    data: { permissions: string[] }
  ): Promise<IJSONAPIBandUserPermissionsCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const bandUser: unknown = await APIService.put({
          path: API_ENDPOINTS.USER_PERMISSIONS(userId),
          data,
        });
        resolve(bandUser as IJSONAPIBandUserPermissionsCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(
          API_ERROR_CODES.PATCH_USER_PERMISSIONS
        );
        reject(error);
      }
    });
}
